import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const ComponentWrapper = styled.div`
  padding: 40px 24px;
  ${QUERIES.largeTabletAndUp} {
    padding: 80px 48px;
  }
`;

export const ComponentContainer = styled.div`
  max-width: 1116px;
  margin: 0 auto;
`;
